import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";
import ErrorPage from "@/pages/Error/Error";

// utilities
import Login from "@/pages/Login/Login";
import Register from "@/pages/Register/Register";

// Main
import AnalyticsPage from "@/pages/Dashboard/Dashboard";

// sale
import CashSaleList from "@/pages/CashSale/CashSale";
import CashSaleEdit from "@/pages/Dashboard/Dashboard";
import CashSale from "@/pages/CashSale/CashSale";

import CreditNoteList from "@/pages/CreditNote/CreditNoteList";
import CreditNoteEdit from "@/pages/CreditNote/CreditNoteEdit";
import CreditNote from "@/pages/CreditNote/CreditNote";

import CustomerList from "@/pages/Customer/CustomerList";
import CustomerEdit from "@/pages/Customer/CustomerEdit";
import Customer from "@/pages/Customer/Customer";

import CustomerCategoryList from "@/pages/Dashboard/Dashboard";
import CustomerCategoryEdit from "@/pages/Dashboard/Dashboard";
import CustomerCategory from "@/pages/Dashboard/Dashboard";

import CustomerEnquiry from "@/pages/Dashboard/Dashboard";

import CustomerPostingCategoryList from "@/pages/Dashboard/Dashboard";
import CustomerPostingCategoryEdit from "@/pages/Dashboard/Dashboard";
import CustomerPostingCategory from "@/pages/Dashboard/Dashboard";

import CustomerQuotesList from "@/pages/Dashboard/Dashboard";
import CustomerQuotesEdit from "@/pages/Dashboard/Dashboard";
import CustomerQuotes from "@/pages/Dashboard/Dashboard";

import DeliveryNotesList from "@/pages/Dashboard/Dashboard";
import DeliveryNotesEdit from "@/pages/Dashboard/Dashboard";
import DeliveryNotes from "@/pages/Dashboard/Dashboard";

import OnlineSalesList from "@/pages/Dashboard/Dashboard";
import OnlineSalesEdit from "@/pages/Dashboard/Dashboard";
import OnlineSales from "@/pages/Dashboard/Dashboard";

import SaleInvoiceList from "@/pages/Dashboard/Dashboard";
import SaleInvoiceEdit from "@/pages/Dashboard/Dashboard";
import SaleInvoice from "@/pages/Dashboard/Dashboard";

import SaleSettings from "@/pages/Dashboard/Dashboard";

// inventory
import BranchOrderList from "@/pages/Dashboard/Dashboard";
import BranchOrderEdit from "@/pages/Dashboard/Dashboard";
import BranchOrder from "@/pages/Dashboard/Dashboard";

import BranchReceiptList from "@/pages/Dashboard/Dashboard";
import BranchReceiptEdit from "@/pages/Dashboard/Dashboard";
import BranchReceipt from "@/pages/Dashboard/Dashboard";

import BranchTransferList from "@/pages/Dashboard/Dashboard";
import BranchTransferEdit from "@/pages/Dashboard/Dashboard";
import BranchTransfer from "@/pages/Dashboard/Dashboard";

import StockList from "@/pages/Dashboard/Dashboard";
import StockEdit from "@/pages/Dashboard/Dashboard";
import Stock from "@/pages/Dashboard/Dashboard";

import InventoryJournalList from "@/pages/Dashboard/Dashboard";
import InventoryJournalEdit from "@/pages/Dashboard/Dashboard";
import InventoryJournal from "@/pages/Dashboard/Dashboard";

import ItemGroupList from "@/pages/Dashboard/Dashboard";
import ItemGroupEdit from "@/pages/Dashboard/Dashboard";
import ItemGroup from "@/pages/Dashboard/Dashboard";

import ManufacturerList from "@/pages/Dashboard/Dashboard";
import ManufacturerEdit from "@/pages/Dashboard/Dashboard";
import Manufacturer from "@/pages/Dashboard/Dashboard";

import StockEnquiry from "@/pages/Dashboard/Dashboard";

import StockTakingList from "@/pages/Dashboard/Dashboard";
import StockTakingEdit from "@/pages/Dashboard/Dashboard";
import StockTaking from "@/pages/Dashboard/Dashboard";

// accounting
import AccountList from "@/pages/Dashboard/Dashboard";
import AccountEdit from "@/pages/Dashboard/Dashboard";
import Account from "@/pages/Dashboard/Dashboard";

import JournalEntryList from "@/pages/Dashboard/Dashboard";
import JournalEntryEdit from "@/pages/Dashboard/Dashboard";
import JournalEntry from "@/pages/Dashboard/Dashboard";

import PaymentList from "@/pages/Dashboard/Dashboard";
import PaymentEdit from "@/pages/Dashboard/Dashboard";
import Payment from "@/pages/Dashboard/Dashboard";

import PaymentMethodList from "@/pages/Dashboard/Dashboard";
import PaymentMethodEdit from "@/pages/Dashboard/Dashboard";
import PaymentMethod from "@/pages/Dashboard/Dashboard";

import ReceiptList from "@/pages/Dashboard/Dashboard";
import ReceiptEdit from "@/pages/Dashboard/Dashboard";
import Receipt from "@/pages/Dashboard/Dashboard";

import TaxTypeList from "@/pages/Dashboard/Dashboard";
import TaxTypeEdit from "@/pages/Dashboard/Dashboard";
import TaxType from "@/pages/Dashboard/Dashboard";

// suppliers
import GoodsReceivedList from "@/pages/Dashboard/Dashboard";
import GoodsReceivedEdit from "@/pages/Dashboard/Dashboard";
import GoodsReceived from "@/pages/Dashboard/Dashboard";

import GoodsReturnedList from "@/pages/Dashboard/Dashboard";
import GoodsReturnedEdit from "@/pages/Dashboard/Dashboard";
import GoodsReturned from "@/pages/Dashboard/Dashboard";

import PurchaseOrderList from "@/pages/Dashboard/Dashboard";
import PurchaseOrderEdit from "@/pages/Dashboard/Dashboard";
import PurchaseOrder from "@/pages/Dashboard/Dashboard";

import SupplierList from "@/pages/Dashboard/Dashboard";
import SupplierEdit from "@/pages/Dashboard/Dashboard";
import Supplier from "@/pages/Dashboard/Dashboard";

import SupplierEnquiry from "@/pages/Dashboard/Dashboard";

import SupplierInvoiceList from "@/pages/Dashboard/Dashboard";
import SupplierInvoiceEdit from "@/pages/Dashboard/Dashboard";
import SupplierInvoice from "@/pages/Dashboard/Dashboard";

// reports
import SystemReportList from "@/pages/Dashboard/Dashboard";
import SystemReportEdit from "@/pages/Dashboard/Dashboard";
import SystemReport from "@/pages/Dashboard/Dashboard";

import ReportGroupList from "@/pages/Dashboard/Dashboard";
import ReportGroupEdit from "@/pages/Dashboard/Dashboard";
import ReportGroup from "@/pages/Dashboard/Dashboard";

// system
import AlertList from "@/pages/Dashboard/Dashboard";
import AlertEdit from "@/pages/Dashboard/Dashboard";
import Alert from "@/pages/Dashboard/Dashboard";

import AlertTypeList from "@/pages/Dashboard/Dashboard";
import AlertTypeEdit from "@/pages/Dashboard/Dashboard";
import AlertType from "@/pages/Dashboard/Dashboard";

import BranchList from "@/pages/Dashboard/Dashboard";
import BranchEdit from "@/pages/Dashboard/Dashboard";
import Branch from "@/pages/Dashboard/Dashboard";

import LocationsList from "@/pages/Dashboard/Dashboard";
import LocationsEdit from "@/pages/Dashboard/Dashboard";
import Locations from "@/pages/Dashboard/Dashboard";

import RoleList from "@/pages/Dashboard/Dashboard";
import RoleEdit from "@/pages/Dashboard/Dashboard";
import Role from "@/pages/Dashboard/Dashboard";

import SpecialPermissionsList from "@/pages/Dashboard/Dashboard";
import SpecialPermissionsEdit from "@/pages/Dashboard/Dashboard";
import SpecialPermissions from "@/pages/Dashboard/Dashboard";

import SystemSettings from "@/pages/Dashboard/Dashboard";

import UserList from "@/pages/Dashboard/Dashboard";
import UserEdit from "@/pages/Dashboard/Dashboard";
import User from "@/pages/Dashboard/Dashboard";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorPage
    },
    {
      path: "/app",
      name: "Layout",
      component: Layout,
      children: [
        {
          path: "dashboard",
          name: "AnalyticsPage",
          component: AnalyticsPage
        },
        {
          path: "sales/cashsale",
          name: "CashSaleList",
          component: CashSaleList
        },
        {
          path: "sales/cashsale-edit/:id",
          name: "CashSaleEdit",
          component: CashSaleEdit
        },
        {
          path: "sales/cashsale/:id",
          name: "CashSale",
          component: CashSale
        },
        {
          path: "sales/creditnote",
          name: "CreditNoteList",
          component: CreditNoteList
        },
        {
          path: "sales/creditnote-edit/:id",
          name: "CreditNoteEdit",
          component: CreditNoteEdit
        },
        {
          path: "sales/creditnote/:id",
          name: "CreditNote",
          component: CreditNote
        },
        {
          path: "sales/customers",
          name: "CustomerList",
          component: CustomerList
        },
        {
          path: "sales/customers-edit/:id",
          name: "CustomerEdit",
          component: CustomerEdit
        },
        {
          path: "sales/customers/:id",
          name: "Customer",
          component: Customer
        },
        {
          path: "sales/customercategory",
          name: "CustomerCategoryList",
          component: CustomerCategoryList
        },
        {
          path: "sales/customercategory-edit/:id",
          name: "CustomerCategoryEdit",
          component: CustomerCategoryEdit
        },
        {
          path: "sales/customercategory/:id",
          name: "CustomerCategory",
          component: CustomerCategory
        },
        {
          path: "sales/customerenquiry",
          name: "CustomerEnquiry",
          component: CustomerEnquiry
        },
        {
          path: "sales/customerpostingcategory",
          name: "CustomerPostingCategoryList",
          component: CustomerPostingCategoryList
        },
        {
          path: "sales/customerpostingcategory-edit/:id",
          name: "CustomerPostingCategoryEdit",
          component: CustomerPostingCategoryEdit
        },
        {
          path: "sales/customerpostingcategory/:id",
          name: "CustomerPostingCategory",
          component: CustomerPostingCategory
        },
        {
          path: "sales/customerquotes",
          name: "CustomerQuotesList",
          component: CustomerQuotesList
        },
        {
          path: "sales/customerquotes-edit/:id",
          name: "CustomerQuotesEdit",
          component: CustomerQuotesEdit
        },
        {
          path: "sales/customerquotes/:id",
          name: "CustomerQuotes",
          component: CustomerQuotes
        },
        {
          path: "sales/deliverynotes",
          name: "DeliveryNotesList",
          component: DeliveryNotesList
        },
        {
          path: "sales/deliverynotes-edit/:id",
          name: "DeliveryNotesEdit",
          component: DeliveryNotesEdit
        },
        {
          path: "sales/deliverynotes/:id",
          name: "DeliveryNotes",
          component: DeliveryNotes
        },
        {
          path: "sales/onlinesales",
          name: "OnlineSalesList",
          component: OnlineSalesList
        },
        {
          path: "sales/onlinesales-edit/:id",
          name: "OnlineSalesEdit",
          component: OnlineSalesEdit
        },
        {
          path: "sales/onlinesales/:id",
          name: "OnlineSales",
          component: OnlineSales
        },
        {
          path: "sales/saleinvoice",
          name: "SaleInvoiceList",
          component: SaleInvoiceList
        },
        {
          path: "sales/saleinvoice-edit/:id",
          name: "SaleInvoiceEdit",
          component: SaleInvoiceEdit
        },
        {
          path: "sales/saleinvoice/:id",
          name: "SaleInvoice",
          component: SaleInvoice
        },
        {
          path: "sales/salesettings",
          name: "SaleSettings",
          component: SaleSettings
        },
        {
          path: "invetory/branchorder",
          name: "BranchOrderList",
          component: BranchOrderList
        },
        {
          path: "invetory/branchorder-edit/:id",
          name: "BranchOrderEdit",
          component: BranchOrderEdit
        },
        {
          path: "invetory/branchorder/:id",
          name: "BranchOrder",
          component: BranchOrder
        },
        {
          path: "invetory/branchreceipt",
          name: "BranchReceiptList",
          component: BranchReceiptList
        },
        {
          path: "invetory/branchreceipt-edit/:id",
          name: "BranchReceiptEdit",
          component: BranchReceiptEdit
        },
        {
          path: "invetory/branchreceipt/:id",
          name: "BranchReceipt",
          component: BranchReceipt
        },
        {
          path: "invetory/branchtransfer",
          name: "BranchTransferList",
          component: BranchTransferList
        },
        {
          path: "invetory/branchtransfer-edit/:id",
          name: "BranchTransferEdit",
          component: BranchTransferEdit
        },
        {
          path: "invetory/branchtransfer/:id",
          name: "BranchTransfer",
          component: BranchTransfer
        },
        {
          path: "invetory/stock",
          name: "StockList",
          component: StockList
        },
        {
          path: "invetory/stock-edit/:id",
          name: "StockEdit",
          component: StockEdit
        },
        {
          path: "invetory/stock/:id",
          name: "Stock",
          component: Stock
        },
        {
          path: "invetory/inventoryjournal",
          name: "InventoryJournalList",
          component: InventoryJournalList
        },
        {
          path: "invetory/inventoryjournal-edit/:id",
          name: "InventoryJournalEdit",
          component: InventoryJournalEdit
        },
        {
          path: "invetory/inventoryjournal/:id",
          name: "InventoryJournal",
          component: InventoryJournal
        },
        {
          path: "invetory/itemgroup",
          name: "ItemGroupList",
          component: ItemGroupList
        },
        {
          path: "invetory/itemgroup-edit/:id",
          name: "ItemGroupEdit",
          component: ItemGroupEdit
        },
        {
          path: "invetory/itemgroup/:id",
          name: "ItemGroup",
          component: ItemGroup
        },
        {
          path: "invetory/manufacturer",
          name: "ManufacturerList",
          component: ManufacturerList
        },
        {
          path: "invetory/manufacturer-edit/:id",
          name: "ManufacturerEdit",
          component: ManufacturerEdit
        },
        {
          path: "invetory/manufacturer/:id",
          name: "Manufacturer",
          component: Manufacturer
        },
        {
          path: "invetory/stockenquiry",
          name: "StockEnquiry",
          component: StockEnquiry
        },
        {
          path: "invetory/stocktaking",
          name: "StockTakingList",
          component: StockTakingList
        },
        {
          path: "invetory/stocktaking-edit/:id",
          name: "StockTakingEdit",
          component: StockTakingEdit
        },
        {
          path: "invetory/stocktaking/:id",
          name: "StockTaking",
          component: StockTaking
        },
        {
          path: "accounting/account",
          name: "AccountList",
          component: AccountList
        },
        {
          path: "accounting/account-edit/:id",
          name: "AccountEdit",
          component: AccountEdit
        },
        {
          path: "accounting/account/:id",
          name: "Account",
          component: Account
        },
        {
          path: "accounting/journalentry",
          name: "JournalEntryList",
          component: JournalEntryList
        },
        {
          path: "accounting/journalentry-edit/:id",
          name: "JournalEntryEdit",
          component: JournalEntryEdit
        },
        {
          path: "accounting/journalentry/:id",
          name: "JournalEntry",
          component: JournalEntry
        },
        {
          path: "accounting/payment",
          name: "PaymentList",
          component: PaymentList
        },
        {
          path: "accounting/payment-edit/:id",
          name: "PaymentEdit",
          component: PaymentEdit
        },
        {
          path: "accounting/payment/:id",
          name: "Payment",
          component: Payment
        },
        {
          path: "accounting/paymentmethod",
          name: "PaymentMethodList",
          component: PaymentMethodList
        },
        {
          path: "accounting/paymentmethod-edit/:id",
          name: "PaymentMethodEdit",
          component: PaymentMethodEdit
        },
        {
          path: "accounting/paymentmethod/:id",
          name: "PaymentMethod",
          component: PaymentMethod
        },
        {
          path: "accounting/receipt",
          name: "ReceiptList",
          component: ReceiptList
        },
        {
          path: "accounting/receipt-edit/:id",
          name: "ReceiptEdit",
          component: ReceiptEdit
        },
        {
          path: "accounting/receipt/:id",
          name: "Receipt",
          component: Receipt
        },
        {
          path: "accounting/taxtype",
          name: "TaxTypeList",
          component: TaxTypeList
        },
        {
          path: "accounting/taxtype-edit/:id",
          name: "TaxTypeEdit",
          component: TaxTypeEdit
        },
        {
          path: "accounting/taxtype/:id",
          name: "TaxType",
          component: TaxType
        },
        {
          path: "suppliers/goodsreceived",
          name: "GoodsReceivedList",
          component: GoodsReceivedList
        },
        {
          path: "suppliers/goodsreceived-edit/:id",
          name: "GoodsReceivedEdit",
          component: GoodsReceivedEdit
        },
        {
          path: "suppliers/goodsreceived/:id",
          name: "GoodsReceived",
          component: GoodsReceived
        },
        {
          path: "suppliers/goodsreturned",
          name: "GoodsReturnedList",
          component: GoodsReturnedList
        },
        {
          path: "suppliers/goodsreturned-edit/:id",
          name: "GoodsReturnedEdit",
          component: GoodsReturnedEdit
        },
        {
          path: "suppliers/goodsreturned/:id",
          name: "GoodsReturned",
          component: GoodsReturned
        },
        {
          path: "suppliers/purchaseorder",
          name: "PurchaseOrderList",
          component: PurchaseOrderList
        },
        {
          path: "suppliers/purchaseorder-edit/:id",
          name: "PurchaseOrderEdit",
          component: PurchaseOrderEdit
        },
        {
          path: "suppliers/purchaseorder/:id",
          name: "PurchaseOrder",
          component: PurchaseOrder
        },
        {
          path: "suppliers/supplier",
          name: "SupplierList",
          component: SupplierList
        },
        {
          path: "suppliers/supplier-edit/:id",
          name: "SupplierEdit",
          component: SupplierEdit
        },
        {
          path: "suppliers/supplier/:id",
          name: "Supplier",
          component: Supplier
        },
        {
          path: "suppliers/supplierenquiry",
          name: "SupplierEnquiry",
          component: SupplierEnquiry
        },
        {
          path: "suppliers/supplierinvoice",
          name: "SupplierInvoiceList",
          component: SupplierInvoiceList
        },
        {
          path: "suppliers/supplierinvoice-edit/:id",
          name: "SupplierInvoiceEdit",
          component: SupplierInvoiceEdit
        },
        {
          path: "suppliers/supplierinvoice/:id",
          name: "SupplierInvoice",
          component: SupplierInvoice
        },
        {
          path: "reports/systemreport",
          name: "SystemReportList",
          component: SystemReportList
        },
        {
          path: "reports/systemreport-edit/:id",
          name: "SystemReportEdit",
          component: SystemReportEdit
        },
        {
          path: "reports/systemreport/:id",
          name: "SystemReport",
          component: SystemReport
        },
        {
          path: "reports/reportgroup",
          name: "ReportGroupList",
          component: ReportGroupList
        },
        {
          path: "reports/reportgroup-edit/:id",
          name: "ReportGroupEdit",
          component: ReportGroupEdit
        },
        {
          path: "reports/reportgroup/:id",
          name: "ReportGroup",
          component: ReportGroup
        },
        {
          path: "system/alerts",
          name: "AlertList",
          component: AlertList
        },
        {
          path: "system/alerts-edit/:id",
          name: "AlertEdit",
          component: AlertEdit
        },
        {
          path: "system/alerts/:id",
          name: "Alert",
          component: Alert
        },
        {
          path: "system/alerttype",
          name: "AlertTypeList",
          component: AlertTypeList
        },
        {
          path: "system/alerttype-edit/:id",
          name: "AlertTypeEdit",
          component: AlertTypeEdit
        },
        {
          path: "system/alerttype/:id",
          name: "AlertType",
          component: AlertType
        },
        {
          path: "system/branch",
          name: "BranchList",
          component: BranchList
        },
        {
          path: "system/branch-edit/:id",
          name: "BranchEdit",
          component: BranchEdit
        },
        {
          path: "system/branch/:id",
          name: "Branch",
          component: Branch
        },
        {
          path: "system/location",
          name: "LocationsList",
          component: LocationsList
        },
        {
          path: "system/location-edit/:id",
          name: "LocationsEdit",
          component: LocationsEdit
        },
        {
          path: "system/location/:id",
          name: "Locations",
          component: Locations
        },
        {
          path: "system/roles",
          name: "RoleList",
          component: RoleList
        },
        {
          path: "system/roles-edit/:id",
          name: "RoleEdit",
          component: RoleEdit
        },
        {
          path: "system/roles/:id",
          name: "Role",
          component: Role
        },
        {
          path: "system/specialpermission",
          name: "SpecialPermissionsList",
          component: SpecialPermissionsList
        },
        {
          path: "system/specialpermission-edit/:id",
          name: "SpecialPermissionsEdit",
          component: SpecialPermissionsEdit
        },
        {
          path: "system/specialpermission/:id",
          name: "SpecialPermissions",
          component: SpecialPermissions
        },
        {
          path: "system/systemsettings",
          name: "SystemSettings",
          component: SystemSettings
        },
        {
          path: "system/users",
          name: "UserList",
          component: UserList
        },
        {
          path: "system/users-edit/:id",
          name: "UserEdit",
          component: UserEdit
        },
        {
          path: "system/users/:id",
          name: "User",
          component: User
        }
      ]
    }
  ]
});
